import { base, sepolia } from "viem/chains";

export const UNISWAP_API_PATH = "/api/uniswap";
export const UNISWAP_POOL_URL = "https://app.uniswap.org/explore/pools/base";
export const IS_MAINNET = process.env.NEXT_PUBLIC_IS_MAINNET === "true";
export const CHAIN = IS_MAINNET ? base : sepolia;
export const CHAIN_ID = CHAIN.id;
